import config from '@/config';

export default {
    baseUrl: `${config.server.host}:${config.server.port}/api-v2`,
    baseUrlWithoutApi: `${config.server.host}:${config.server.port}`,
    baseUrlPayment: `${config.server.paymentHost}:${config.server.paymentPort}/v1`,
}
